import { LiveUpdaterClient } from 'app/scripts/init/live-updater-client';

// eslint-disable-next-line @trello/no-module-logic
export const classicUpdaterClient = new LiveUpdaterClient();
